import { types } from 'mobx-state-tree';
import Modal from './Modal';

const AddressBookModal = Modal.named('AddressBookModal');

export default AddressBookModal;
